import {
    Box,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Stack,
    Text,
    Button,
    Flex,
    Image,
    AlertDialog,
    Center,
  } from "@chakra-ui/react";

  
import React, { useState } from 'react'
import AlertDialogExample from "../Components/AlertDialog";
const initState={
  "name" : "",
  "card_Number" : "",
  "Expiry" : "",
  "CVV" : ""
}
const PaymentPage = () => {
  const [state, setState] = useState(initState);


   const handleChange=(e)=>{
    const {name, value  }=e.target;
    
    setState({...state, [name] : value })
   }
 
  return (
    <div> 
            <Heading mt={10}>Pay Via Card </Heading>
           <Center rounded={"lg"} boxShadow={"lg"} p={2}>
              <form>
                <Stack spacing={4}>
                  <FormControl>
                    <FormLabel>Delivery</FormLabel>
                    <Input type="text" placeholder="Card Holder Name" 
                     name = "name"
                     value={state.name}
                     onChange={handleChange}
                    required/>
                  </FormControl>

                  <Flex gap={4}>
                    <FormControl>
                      <Input type="text" placeholder="Card Number" 
                       name = "card_Number"
                       value={state.card_Number }
                       onChange={handleChange}
                      required/>
                    </FormControl>
                    <FormControl>
                      <Input type="text" placeholder="Expiry"
                        name = "Expiry"
                        value={state.Expiry }
                        onChange={handleChange}
                      required/>
                    </FormControl>
                  </Flex>

                  <FormControl>
                    <Input type="text" placeholder="Expiry"  
                      name = "CVV"
                      value={state.CVV }
                      onChange={handleChange}
                    required/>
                  </FormControl>
 
             
                  <Stack spacing={10}>
                    <Button mb={20}
                      bg={"green.400"}
                      color={"white"}
                      _hover={{
                        bg: "green.500",
                      }}
                      isDisabled={state.name==="" || state.CVV==="" || state.Expiry===""  || state.card_Number===""}
                      
                    >
            < AlertDialogExample /> 
      
                    </Button>
                  </Stack>
                </Stack>
              </form>
            <Image ml = {200} src="https://www.ccavenue.com/images_mcpg/tappay-front-img.png" mb={100}/>   
            </Center>  
    </div>
  )
}

export default PaymentPage